import { z } from "zod";

export const schema = z.object({
	id_produto: z.number().int("Verifique o id_produto antes de continuar"),
	id_funcionario: z.number().int("Verifique o id_produto antes de continuar"),
	id_subgrupo: z.number().int("Verifique o id_subgrupo antes de continuar"),
	id_grupo: z.number().int(1, "Descrição é obrigatória"),
	id_tipoproduto: z.number().int("Verifique o id_tipoproduto antes de continuar"),
	categoria_nome: z.string().min(1, "Nome da categoria é obrigatório"),

	ordemcategoria: z
		.number()
		.int()
		.nullable()
		.transform((value) => value ?? 0),

	nome: z.string().min(1, "Campo descrição é obrigatório"),
	ean: z.string().min(1, "Campo Ean é obrigatório"),
	und: z.string().min(1, "Campo Und é obrigatório"),
	ativo: z.boolean(),
	ativoapi: z.boolean(),
	destaque: z.boolean(),
	mais_pedidos: z.boolean(),
	balanca: z.boolean(),
	urlfoto: z.string().nullable(),
	qtatual: z.string().min(1, "Estoque é obrigatório"),
	valor: z.string().min(1, "Valor é obrigatório"),
	custo: z
		.string()
		.nullable()
		.transform((value) => value ?? "0"),
	rendimento: z.string().nullable(),

	lucro: z.string().min(1, "Custo é obrigatório"),
	markup: z.string().min(1, "Markup é obrigatório"),

	descricaoapi: z.string().nullable(),
	valorpromoapi: z
		.string()
		.nullable()
		.transform((value) => value ?? "0"),

	prod_promocao: z.string().nullable(),
	qtcritica: z.string().min(1, "Qtde. crítica é obrigatório"),
	qtde: z.number(),
	referencia: z.string().nullable(),
	descmax: z.string().nullable(),
	comissao: z.string().nullable(),
	fracao: z.string().nullable(),
	data: z.string(),
	largura: z.preprocess((val) => {
		if (val === null || val === "" || val === undefined) return null;
		if (typeof val === "number") return val;
		const parsed = parseFloat(String(val).replace(",", "."));
		return isNaN(parsed) ? val : parsed;
	}, z.number({ invalid_type_error: "Informe um número válido" }).nullable()),
	
	comprimento: z.preprocess((val) => {
		if (val === null || val === "" || val === undefined) return null;
		if (typeof val === "number") return val;
		const parsed = parseFloat(String(val).replace(",", "."));
		return isNaN(parsed) ? val : parsed;
	}, z.number({ invalid_type_error: "Informe um número válido" }).nullable()),
	
	altura: z.preprocess((val) => {
		if (val === null || val === "" || val === undefined) return null;
		if (typeof val === "number") return val;
		const parsed = parseFloat(String(val).replace(",", "."));
		return isNaN(parsed) ? val : parsed;
	}, z.number({ invalid_type_error: "Informe um número válido" }).nullable()),
	
	pesobruto: z.preprocess((val) => {
		if (val === null || val === "" || val === undefined) return null;
		if (typeof val === "number") return val;
		const parsed = parseFloat(String(val).replace(",", "."));
		return isNaN(parsed) ? val : parsed;
	}, z.number({ invalid_type_error: "Informe um número válido" }).nullable()),
	fragil: z
		.boolean()
		.nullable()
		.transform((value) => value ?? false),
	caixa_propria: z
		.boolean()
		.nullable()
		.transform((value) => value ?? false),
});

// Função para converter vírgula para ponto

// valor: z
// 	.number({
// 		errorMap: () => {
// 			return { message: "Informe um número válido" };
// 		},
// 	})
// 	.positive("Por favor, informe um número maior que 0"),
// rendimento: z.number().min(1, "Campo Rendimento é obrigatório"),
